// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18Q1J","col":"styles_col__16OmE"};